export default __webpack_public_path__ + "static/media/logos1.73306db4.webp";